module.exports = __webpack_public_path__ + "img/prequal.388b9bf.jpg";